import FormPrisma from "./Form"

export default function EditPrisma() {
    return (
        <FormPrisma data={JSON.parse(localStorage.getItem("prisma"))} />
    )
}